import { roundN } from "./roundN";

// // // //

/**
 * Formats APY value to 2 decimals
 * @param apy - non-percent number
 * @returns
 */
export function formatApy(apy: number): number {
    return roundN(apy * 100, 2);
}

/**
 * Formats percent value to 2 decimals with comma-separated thousands
 * @param value - non-percent number
 * @returns
 */
// export function formatPercent(value: number): string {
//     // Check if the absolute value of the number is less than 100
//     const lessThan100 = Math.abs(value) < 100;
//     const lessThan1000 = Math.abs(value) < 1000;

//     const sigfigs = lessThan100 ? 2 : lessThan1000 ? 1 : 0;

//     // Update this
//     return Math.abs(formatApy(value)).toLocaleString(undefined, {
//         minimumFractionDigits: sigfigs,
//         maximumFractionDigits: sigfigs,
//     });
// }

// PercentageDisplay requirements notes:
// - Should be able to auto-set sigfigs, or override
// - Should be able to optionally include signage both before + after the value (i.e. +10% or -10%) for both positive + negative values
// - Color display could be integrated
// - Arrow display could be integrated
